import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { StockLanding } from 'components/StockLanding';
import NotFound from 'shared/components/NotFound';

interface RouteProps {
  id: string;
}

export default ({ match: { params } }: RouteComponentProps<RouteProps>) =>
  !isNaN(+params.id) ? <StockLanding id={Number(params.id)} /> : <NotFound />;
